<template><section><h1>Button 按钮</h1>
<h2>基本用法</h2>
<h3>按钮类型</h3>
<p>需要传递type属性,支持 <strong>default、primary、danger、warn</strong> 四种类型，默认为 <strong>default</strong></p>
<demo-block>
                    <div class="source" slot="source"><nt-button>默认按钮</nt-button>
<nt-button type="primary">百搭按钮</nt-button>
<nt-button type="danger">危险按钮</nt-button>
<nt-button type="warn">警告按钮</nt-button>
</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span>&gt;</span>默认按钮<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span> &gt;</span>百搭按钮<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"danger"</span>  &gt;</span>危险按钮<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"warn"</span>    &gt;</span>警告按钮<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>按钮尺寸</h3>
<p>需要传递size属性,支持 <strong>large、normal、small</strong> 三种类型，默认为 <strong>normal</strong></p>
<demo-block>
                    <div class="source" slot="source"><nt-button size="large">默认按钮</nt-button>
<nt-button>默认按钮</nt-button>
<nt-button size="small">默认按钮</nt-button>
</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"large"</span>&gt;</span>默认按钮<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span>&gt;</span>默认按钮<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"small"</span>&gt;</span>默认按钮<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>按钮禁用</h3>
<p>需要传递disabled属性,支持 <strong>true,false</strong> 两种类型，默认为 <strong>false</strong>,类型为Boolean,因此需要在disabled前加&quot;:&quot;</p>
<demo-block>
                    <div class="source" slot="source"><nt-button :disabled="true">默认按钮</nt-button>
<nt-button :disabled="true" type="primary">百搭按钮</nt-button>
<nt-button :disabled="true" type="danger">危险按钮</nt-button>
<nt-button :disabled="true" type="warn">警告按钮</nt-button>
</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">:disabled</span>=<span class="hljs-string">"true"</span>&gt;</span>默认按钮<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">:disabled</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span> &gt;</span>百搭按钮<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">:disabled</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"danger"</span>  &gt;</span>危险按钮<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">:disabled</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"warn"</span>    &gt;</span>警告按钮<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>块级按钮</h3>
<p>需要传递long属性,支持 <strong>true,false</strong> 两种类型，默认为 <strong>false</strong></p>
<demo-block>
                    <div class="source" slot="source"><nt-button type="primary" size="small" :long="false">百搭按钮</nt-button>
<nt-button type="primary" size="small" :long="true">百搭按钮</nt-button>
</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"small"</span> <span class="hljs-attr">:long</span>=<span class="hljs-string">"false"</span>&gt;</span>百搭按钮<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"small"</span> <span class="hljs-attr">:long</span>=<span class="hljs-string">"true"</span>&gt;</span>百搭按钮<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>按钮事件</h3>
<p>直接在组件上绑定@click即可,不需要特殊传递事件</p>
<demo-block>
                    <div class="source" slot="source">
<template>
    <nt-button @click="handleClick">点我一下</nt-button> 
</template>


</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html">
<span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"handleClick"</span>&gt;</span>点我一下<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span> 
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span>{
    <span class="hljs-attr">methods</span>:{
        handleClick(){
            alert(<span class="hljs-string">'欢迎来到nature-ui大事件'</span>)
        }
    }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">type</td>
<td style="text-align:left">按钮类型</td>
<td style="text-align:left">string</td>
<td style="text-align:left"><code v-pre>default</code> <code v-pre>primary</code> <code v-pre>danger</code>  <code v-pre>warn</code></td>
<td style="text-align:left"><code v-pre>default</code></td>
</tr>
<tr>
<td style="text-align:left">size</td>
<td style="text-align:left">按钮 大小</td>
<td style="text-align:left">string</td>
<td style="text-align:left"><code v-pre>normal</code> <code v-pre>large</code>  <code v-pre>small</code></td>
<td style="text-align:left"><code v-pre>normal</code></td>
</tr>
<tr>
<td style="text-align:left">disabled</td>
<td style="text-align:left">按钮是否禁用</td>
<td style="text-align:left">boolean</td>
<td style="text-align:left"><code v-pre>true</code> <code v-pre>false</code></td>
<td style="text-align:left"><code v-pre>false</code></td>
</tr>
<tr>
<td style="text-align:left">long</td>
<td style="text-align:left">是否为块状按钮</td>
<td style="text-align:left">boolean</td>
<td style="text-align:left"><code v-pre>true</code> <code v-pre>false</code></td>
<td style="text-align:left"><code v-pre>false</code></td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th style="text-align:left">事件名称</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">click</td>
<td style="text-align:left">点击操作</td>
<td style="text-align:left"></td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default{
    methods:{
        handleClick(){
            alert('欢迎来到nature-ui大事件')
        }
    }
}
</script>